<div class="registration-container" *ngIf="showContent">  <!-- Toast Message Component -->
  <div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
      <div class="toast-content">
        <div class="toast-text">
          <div class="toast-title">{{ toastTitle }}</div>
          <div class="toast-message-text">{{ toastMessage }}</div>
        </div>
      <span class="material-symbols-outlined p-0 cursor-pointer" 
        id="btn_phone_recovery_email_close_toast"
        (click)="closeToast()"
        (keypress)="closeToast()"
        *ngIf="toastType === 'success' || toastType === 'error'" 
        title="Close">close</span>
      </div>
    </div>
  </div>

  <!-- Combined Header and Content Card -->
  <div class="main-content">
    <div class="content-card">      <!-- Header Section -->
      <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img src="assets/images/edu-logo.svg" alt="NDE logo" class="img-fluid" />
            </div>
        </div>

      <!-- Main Title Section -->
      <h1 class="page-title">Complete Your Registration</h1>
      <p class="page-subtitle">Set your password and verify your contact information to activate your account.</p>      <!-- Email Verification Section -->
      <hr class="section-divider">
      <div class="section">
        <h2 class="section-title">Email Verification</h2>
        <p class="section-subtitle" style="color: #666;">Your email address has been verified.</p>
        
        <div class="form-group">
          <label class="form-label" for="email-input">Email</label>
          <input aria-live="polite" aria-atomic="true"
            id="email-input"
            type="email"
            class="form-input"
            [(ngModel)]="email"
            readonly
          />
        </div>
      </div>

      <!-- Recovery Email Verification Section (show only if not verified) -->
      <hr class="section-divider">
      <div class="section" *ngIf="!isEmailVerified">
        <h2 class="section-title">Recovery Email Verification</h2>
        <p style="color: #666;">Enter the 6-digit code sent to your recovery email address to verify it.</p>
        <div class="form-group">
          <label class="form-label recovery-email-spacing" for="recovery-email-input">Recovery Email</label>
          <input
            id="recovery-email-input"
            type="email"
            class="form-input"
            [(ngModel)]="recoveryEmail"
            readonly
          />
        </div>        

        <div class="form-group">
          <label class="form-label" for="recovery-otp-container">Verification Code <span class="requiredfield text-danger">*</span></label>

          <div class="otp-container">
            <input
              *ngFor="let digit of getInputIds(); let i = index"
              [id]="'recovery-otp-input-' + i"
              type="text"
              class="otp-input"
              [class.error]="(recoveryAttempts > 0 && !isEmailVerified) || recoveryEmptyFieldsAfterBlur[i]"
              maxlength="1"
              (input)="onRecoveryInputChange($event, i)"
              (keydown)="onRecoveryKeyDown($event, i)"
              (paste)="onRecoveryPaste($event)"
              (blur)="onRecoveryInputBlur($event, i)"
              (focus)="onRecoveryInputFocus($event, i)"
              [disabled]="isRecoveryOtpDisabled(i)"
              autocomplete="off"
            />
          </div>
          <div class="error-message-otp" *ngIf="showRecoveryOtpError" aria-live="polite" aria-atomic="true">
             Please enter the verification code sent to your recovery email address.
          </div>        
        </div>        
          
        <div class="resend-section justify-content-center">
          <button
            type="button"
            class="resend-button"
            (click)="onResendRecoveryCode()"
            [disabled]="isResendRecoveryDisabled()"
          >
            Resend Code
          </button>
          <!-- 30s timer for resend, only when not blocked -->
          <span class="timer" *ngIf="recoveryTimeRemaining > 0 && !isBlocked">{{ recoveryFormattedTime }}</span>
          <!-- 15min timer after 5th failed attempt, only when blocked -->
          <span class="timer" *ngIf="recoveryTimeRemaining > 0 && isBlocked">{{ recoveryFormattedTime }}</span>
        </div>

        <button
          *ngIf="!isEmailVerified"
          type="button"
          class="verify-button"
          (click)="onVerifyRecoveryEmail()"
          [disabled]="isBlocked || isEmailVerified || recoveryOtpDigits.length < 6 || recoveryOtpDigits.includes('') || recoveryTimeRemaining > 0"
        >
          Verify Recovery Email
        </button>
        
        <!-- Update Recovery Email Link -->
        <div class="update-phone-container">
          <a href="#" class="update-phone-link" (click)="navigateToUpdateRecoveryEmail(); $event.preventDefault()">Update Recovery Email</a>
        </div>
        
        <!-- Continue without Recovery Email Link -->
        <div class="update-phone-container" style="margin-top: 16px;">
          <a href="#" class="update-phone-link" (click)="continueWithoutRecoveryEmail(); $event.preventDefault()">Continue without Recovery Email</a>
        </div>
      </div>

      <!-- Recovery Email Verified Section -->
      <div class="section" *ngIf="isEmailVerified">
        <h2 class="section-title">Recovery Email Verification</h2>
        
        <div class="form-group recovery-email-field">
          <label for="recovery-email-verified-input" class="form-label">Recovery Email</label>
          <input
            id="recovery-email-verified-input"
            type="email"
            class="form-input"
            [(ngModel)]="recoveryEmail"
            readonly
          />
          <div class="verified-badge">
            <i class="fa fa-check-circle-o"></i>
            <span>Verified</span>
          </div>
        </div>
      </div>

      <!-- Phone Verification Section -->
      <hr class="section-divider">
      <div class="section">
        <h2 class="section-title">Phone Verification</h2>
        <p class="section-subtitle" *ngIf="isEmailVerified">Enter the 6-digit code sent via SMS to verify your phone number.</p>
        <p class="section-subtitle" *ngIf="!isEmailVerified" style="color: #666;">Complete recovery email verification to enable phone verification.</p>
        
        <div class="form-group">
          <label for="phone-input" class="form-label">Phone Number</label>
          <input
            id="phone-input"  
            type="tel"
            class="form-input"
            [(ngModel)]="phoneNumber"
            readonly
          />
        </div>        

  <div class="form-group" *ngIf="isEmailVerified">
          <label for="phone-otp-container" class="form-label">Verification Code <span class="requiredfield text-danger">*</span></label>

          <div class="otp-container">
            <input
              *ngFor="let digit of getInputIds(); let i = index"
              [id]="'phone-otp-input-' + i"
              type="text"
              class="otp-input"
              [class.error]="(phoneAttempts > 0 && !isPhoneVerified) || phoneEmptyFieldsAfterBlur[i]"
              maxlength="1"
              (input)="onPhoneInputChange($event, i)"
              (keydown)="onPhoneKeyDown($event, i)"
              (paste)="onPhonePaste($event)"
              (blur)="onPhoneInputBlur($event, i)"
              (focus)="onPhoneInputFocus($event, i)"
              [disabled]="isPhoneOtpDisabled(i)"
              autocomplete="off"
            />
          </div>
          <div class="error-message-otp" *ngIf="showPhoneOtpError" aria-live="polite" aria-atomic="true">
            Please enter the verification code sent to your phone.
          </div>        
        </div>        
          
        <div class="resend-section justify-content-center" *ngIf="isEmailVerified">
          <button
            type="button"
            class="resend-button"
            (click)="onResendPhoneCode()"
            [disabled]="isResendPhoneDisabled() "
          >
            Resend Code
          </button>
          <!-- 30s timer for resend, only when not blocked -->
          <span class="timer" *ngIf="phoneTimeRemaining > 0 && !isPhoneBlocked">{{ phoneFormattedTime }}</span>
          <!-- 15min timer after 5th failed attempt, only when blocked -->
          <span class="timer" *ngIf="phoneTimeRemaining > 0 && isPhoneBlocked">{{ phoneFormattedTime }}</span>
        </div>

        <button
          *ngIf="!isPhoneVerified && isEmailVerified"
          type="button"
          class="verify-button"
          (click)="onVerifyPhoneNumber()"
          [disabled]="isPhoneBlocked || isPhoneVerified || phoneOtpDigits.length < 6 || phoneOtpDigits.includes('') || !isEmailVerified || phoneTimeRemaining > 0"
        >
          Verify Phone Number
        </button>
        
        <!-- Update Phone Number Link -->
        <div class="update-phone-container" *ngIf="isEmailVerified">
          <a href="#" class="update-phone-link" (click)="navigateToPhoneUpdate(); $event.preventDefault()">Update Phone Number</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation Modal -->
  <div *ngIf="showConfirmModal" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-content">
        <h3 class="modal-title">Continue Without Recovery Email</h3>
        <p class="modal-message">
          Are you sure you want to continue without adding a recovery email? You can add one later in your profile settings.
        </p>
      </div>
      <div class="separator">&nbsp;</div>
      <div class="modal-buttons">
          <button type="button" class="btn btn-outline-secondary modal-button cancel-button w-50" (click)="cancelContinueWithoutRecovery()">
            Cancel
          </button>
          <button type="button" class="btn btn-primary modal-button confirm-button w-50" (click)="confirmContinueWithoutRecovery()">
            Yes, Continue
          </button>
        </div>
    </div>
  </div>
</div>
